
<div class="ui modal"
     id="Qr_Reward_Modal">
  <button class="circular ui icon button"
          style="float: right;margin: 5px"
          (click)="modalHide()">
    <i class="close icon"></i>
  </button>

  <h2 class="qr-info">
    {{"qr" | t}}
  </h2>

  <div class="qr-box" *ngIf="qrCode !=''; else noQr">
    <qrcode [qrdata]="qrCode"
            [width]="320"
            [errorCorrectionLevel]="'M'"></qrcode>

  </div>
  <ng-template #noQr>

    <div class="error-message" style="display: flex;
    justify-content: center;
    font-size: 18px;
    font-weight: 700;">
      <div class="error-message-text" style="color: rgb(156, 156, 156);">
        Something wrong please try again!
      </div>
    </div>
  </ng-template>

  <div class="reward-png" style="
          justify-content: center;
    display: flex;
    align-items: center;
      " >
          <img src="../../../Images/reward.png" style="width: 210px;
         justify-content: center;
    display: flex;" />

      </div>
</div>
